var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOff = function SvgEyeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1F26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m2 2 2.04 2.04m0 0c-1.5 1.182-2.312 2.811-2.626 3.557-.11.26-.11.545 0 .806.522 1.242 2.424 4.93 6.584 4.93a6.26 6.26 0 0 0 3.96-1.374M4.039 4.04l2.075 2.074m.476-3.297c.437-.097.906-.15 1.408-.15 4.158 0 6.062 3.687 6.586 4.93.11.26.11.546 0 .806a10 10 0 0 1-.838 1.569m-1.788 1.987L13.999 14m-2.041-2.041L9.885 9.886M6.114 6.114a2.667 2.667 0 0 0 3.771 3.771m-3.771-3.77 3.77 3.77"
  })));
};
export default SvgEyeOff;